import { useEffect, useState } from "react";

/**
 * A short message saying what a remote button just did, or why it could not
 * (owner, 2026-10-06: favourites "works but needs a message saying it was
 * added or removed"; picture size, audio track, PiP and seeking did nothing a
 * viewer could see). One at a time; a new one replaces the last.
 */
type Listener = (text: string) => void;
const listeners = new Set<Listener>();

export function showRemoteNote(text: string): void {
  for (const listener of listeners) listener(text);
}

/** How long a note stays. */
export const REMOTE_NOTE_MS = 2_500;

/** The note on show, or null. */
export function useRemoteNote(): string | null {
  const [note, setNote] = useState<{ text: string; at: number } | null>(null);
  useEffect(() => {
    const listener: Listener = (text) => setNote({ text, at: Date.now() });
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  useEffect(() => {
    if (!note) return;
    const timer = setTimeout(() => setNote(null), REMOTE_NOTE_MS);
    return () => clearTimeout(timer);
  }, [note]);
  return note?.text ?? null;
}
